import { displayTextOf } from '@repo/shared/orpc/multi-language';
import { TextButton } from 'component/button';
import { InformationalModal } from 'component/modal/informational-modal';
import { useLanguage } from 'component/translation';
import type { Space } from 'data/spaces';
import { View } from 'react-native';
import { t } from 'util/stdtypes';

type QuestionSelectorModalProps = {
    questions: Space[];
    onClose: () => void;
    onSelect: (question: Space) => void;
};

export function QuestionSelectorModal({ questions, onClose, onSelect }: QuestionSelectorModalProps) {
    const isoLocale = useLanguage();
    return (
        <InformationalModal
            content={
                <View style={{ gap: 8 }}>
                    {questions.map((question) => (
                        <TextButton
                            key={question.spaceKey}
                            onPress={() => {
                                onSelect(question);
                            }}
                            text={displayTextOf(question.name, isoLocale)}
                        />
                    ))}
                </View>
            }
            headingLabel={t('videovoting.select_question', 'Select a question')}
            onClose={onClose}
        />
    );
}
